import { render, staticRenderFns } from "./ScreenChronology.vue?vue&type=template&id=3c380526&scoped=true&"
import script from "./ScreenChronology.vue?vue&type=script&lang=js&"
export * from "./ScreenChronology.vue?vue&type=script&lang=js&"
import style0 from "./ScreenChronology.vue?vue&type=style&index=0&id=3c380526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c380526",
  null
  
)

export default component.exports